<template>
    <div class="register__step" data-step="about" v-bind:class="{'active': $store.state.step == 'about'}">
        <h3>About You &amp; Account Information</h3>
        <p>Please tell us a little bit about you and provide your desired account credentials.</p>

        <template v-if="$store.state.signup.vouched.messages.length > 0">
            <div class="alert alert-warning">
                <h6>Validation errors:</h6>
                <ul id="ul-validations">
                    <li v-for="item in $store.state.signup.vouched.messages" v-bind:key="item">
                        {{ item }}
                    </li>
                </ul>
            </div>
        </template>
        
        <fieldset class="register__step-fieldset">
            <legend>Personal Information</legend>
            <small class="register__step-text_note">*The first and last name need to match to the ID.</small>
            <ul class="register__step-fields">
                <li class="register__step-field">
                    <input type="text" id="register_name" autocomplete="chrome-off" name="register_name" class="register__step-field-input" v-model="$store.state.signup.name">
                    <label for="register_name" class="register__step-field-label">Name <small class="register__step-text_note">*</small></label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="email" id="register_email" autocomplete="chrome-off" name="register_email" class="register__step-field-input" v-model="$store.state.signup.email">
                    <label for="register_email" class="register__step-field-label">E-mail</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_phone" autocomplete="chrome-off" name="register_phone" class="register__step-field-input" v-model="$store.state.signup.phone">
                    <label for="register_phone" class="register__step-field-label">Phone #</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="password" id="register_password" autocomplete="new-password" name="register_password" class="register__step-field-input" v-model="$store.state.signup.password">
                    <label for="register_password" class="register__step-field-label">Password</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="password" id="register_password_confirm" autocomplete="new-password" name="register_password_confirm" class="register__step-field-input" v-model="$store.state.signup.password_confirm">
                    <label for="register_password_confirm" class="register__step-field-label">Password (Confirm)</label>
                </li>
            </ul>
        </fieldset>

        <br />

        <fieldset class="register__step-fieldset">
            <legend>Address</legend>
            <ul class="register__step-fields">
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_address_address1" autocomplete="chrome-off" name="register_address_address1" class="register__step-field-input" v-model="$store.state.signup.address.address1">
                    <label for="register_address_address1" class="register__step-field-label">Address1</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_address_address2" autocomplete="chrome-off" name="register_address_address2" class="register__step-field-input" v-model="$store.state.signup.address.address2">
                    <label for="register_address_address2" class="register__step-field-label">Address2</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_address_city" autocomplete="chrome-off" name="register_address_city" class="register__step-field-input" v-model="$store.state.signup.address.city">
                    <label for="register_address_city" class="register__step-field-label">City</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_address_region" autocomplete="chrome-off" name="register_address_region" class="register__step-field-input" v-model="$store.state.signup.address.region">
                    <label for="register_address_region" class="register__step-field-label">Region/State</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <input type="text" id="register_address_postal" autocomplete="chrome-off" name="register_address_postal" class="register__step-field-input" v-model="$store.state.signup.address.postal">
                    <label for="register_address_postal" class="register__step-field-label">Zip/Postal</label>
                </li>
                <li class="register__step-field register__step-field--half">
                    <select id="register_address_country" autocomplete="chrome-off" name="register_address_country" class="register__step-field-input" v-model="$store.state.signup.address.country">
                        <option value="">- Select -</option>
                        <option v-for="item in $store.state.country_list" v-bind:key="item" :value="item.id">{{ item.label_full }}</option>
                    </select>
                    <label for="register_address_country" class="register__step-field-label">Country</label>
                </li>
            </ul>
        </fieldset>

        <br />

        <fieldset class="register__step-fieldset">
            <legend>Identity Validation</legend>            
            <small>
                <span style="font-size: 12pt; letter-spacing: .01em; word-spacing: .05em;line-height: 1.4em;"><strong>Why do we do an ID verification?</strong><br/>We are trying to do our part in making this site as safe and secure as we can. This is our way of trying to give you some piece of mind that the person you are communicating with is who they say they are! We provide 2 ways to do this at sign-up, the automated way or you can by-pass the automation by checking the box and we will verify with you over a video or zoom call.</span>
                <br/>
                <ol class="register__step-field-selections mt-3">
                    <li class="register__step-field-selection">
                        <input type="checkbox" name="register_referral" id="register_vouched_bypass" value="vouched_bypass" v-model="$store.state.signup.vouched_bypass">
                        <label for="register_vouched_bypass" class="register__step-field-label" style="font-size: 13pt; margin: 10px;">Verify through Zoom</label>
                    </li>
                </ol>
            </small>
            

            <template v-if="!$store.state.signup.vouched_bypass">
                <br/>
                <hr style="border: 1px dashed #00a3e5; opacity: .3; color: transparent; margin: 0;"/>
                <br/>
                <p>In order to validate your identity, please insert below a recent front face selfie and front of your ID document (Passport or Driver-License)</p>

                <ul class="register__step-vouched">
                    <li class="register__step-vouched-column">
                        <label>Recent Front Face Selfie <template v-if="!$store.state.loading"> - <a class="removeButton" @click="trigger('userPhoto')">Change</a></template></label>

                        <br/>
                        <div class="photoSection">
                            <template v-if="!$store.state.loading">
                                <input @change="handleImage" type="file" target="userPhoto" ref="userPhoto" accept="image/*" class="photoButton" />
                            </template>

                            <template v-if="userPhoto == ''">
                                <div class="userPhotoWrap" :style="{backgroundImage: `url(/wp-content/uploads/vouched/ImageProfile.png)`}"></div>
                            </template>

                            <template v-if="userPhoto != ''">
                                <div class="userPhotoWrap" :style="{backgroundImage: `url(${userPhoto})`}"></div>
                            </template>

                            
                        </div>
                    </li>
                    <li class="register__step-vouched-column">
                        <label>ID Front <template v-if="!$store.state.loading"> - <a class="removeButton" @click="trigger('idPhoto')">Change</a></template></label>
                        <br/>

                        <div class="photoSection">
                            <template v-if="!$store.state.loading">
                                <input @change="handleImage" type="file" target="idPhoto" ref="idPhoto" accept="image/*" class="photoButton" />
                            </template>

                            <template v-if="idPhoto == ''">
                                <div class="idPhotoWrap" :style="{backgroundImage: `url(/wp-content/uploads/vouched/ImageIDFront.png)`}"></div>
                            </template>

                            <template v-if="idPhoto != ''">
                                <div class="idPhotoWrap" :style="{backgroundImage: `url(${idPhoto})`}"></div>
                            </template>

                            
                        </div>
                    </li>
                </ul>
            </template>


        </fieldset>

        <br />

        <fieldset class="register__step-fieldset">
            <legend>How did you hear about us?</legend>

            <ul class="register__step-fields">
                <li class="register__step-field register__step-field--bright">
                    <ol class="register__step-field-selections">
                        <li class="register__step-field-selection">
                            <input type="radio" name="register_referral" id="register_referral_facebook" value="facebook" v-model="$store.state.signup.referral">
                            <label for="register_referral_facebook" class="register__step-field-label">Facebook</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="radio" name="register_referral" id="register_referral_search" value="search" v-model="$store.state.signup.referral">
                            <label for="register_referral_search" class="register__step-field-label">Search Engine</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="radio" name="register_referral" id="register_referral_advert" value="advert" v-model="$store.state.signup.referral">
                            <label for="register_referral_advert" class="register__step-field-label">Advertisement</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="radio" name="register_referral" id="register_referral_wom" value="wom" v-model="$store.state.signup.referral">
                            <label for="register_referral_wom" class="register__step-field-label">Word of Mouth</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="radio" name="register_referral" id="register_referral_other" value="other" v-model="$store.state.signup.referral">
                            <label for="register_referral_other" class="register__step-field-label">Other</label>
                        </li>
                    </ol>
                </li>
                <li class="register__step-field" v-if="$store.state.signup.referral === 'other' || $store.state.signup.referral === 'advert'">
                    <input type="text" id="register_referral_typein" name="register_referral_typein" class="register__step-field-input" v-model="$store.state.signup.referral_other">
                    <label for="register_referral_typein" class="register__step-field-label">If "Other" or "Advertisement", please specify:</label>
                </li>
            </ul>
        </fieldset>

        <footer class="register__step-footer">
            <button class="btn btn-primary" data-direction="next" v-on:click="$store.dispatch( 'step_control', { to: 'interests' } );">Next <i class="fas fa-chevron-right" aria-hidden="true"></i></button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "DVCARegisterAbout",
    data() {
        return {
            userPhoto: '',
            idPhoto: ''
        }
    },
    methods: {
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.createBase64Image(selectedImage, e.target.getAttribute("target"));
        },
        createBase64Image(fileObject, targetName) {

            if (fileObject==undefined || fileObject==null) {
                this[targetName] = '';
                this.$store.state.signup.vouched.changed = true;
                this.$store.state.signup.vouched[targetName] = '';
            } else {

                const reader = new FileReader();
                reader.onload = (e) => {
                    this[targetName] = e.target.result;
                    this.$store.state.signup.vouched.changed = true;
                    this.$store.state.signup.vouched[targetName] = e.target.result;
                }
                reader.readAsDataURL(fileObject);
            }
        },
        removeImage(targetName) {
            this[targetName] = '';
            this.$store.state.signup.vouched.changed = true;
            this.$store.state.signup.vouched[targetName] = '';
        },
        trigger(name) {
            this.$refs[name].click()
        }        
    }
}
</script>
